import React from "react";
import {Col} from "../../../../styles/Grid";
import styled from "styled-components";
import parse from "html-react-parser";

export default function PrintTypeData({type, data}) {
   if (!data) return null;
   switch (type) {
      case "Facilitators":
         return (
            <Col large={12} className="element">
               <ReadEl>
                  <p>Facilitador:</p>
               </ReadEl>
               <ReadEl>
                  <p>
                     {data.facilitatorName} {data.facilitatorLastName}
                  </p>
               </ReadEl>
            </Col>
         );
      case "Courses":
         return (
            <Col large={12} className="element">
               <ReadEl>
                  <p>Curso:</p>
               </ReadEl>
               <ReadEl>
                  <p>{data.courseName}</p>
               </ReadEl>
            </Col>
         );
      case "Testimonials":
         return (
            <Col large={12} className="element">
               <ReadEl>
                  <p>Testimonial:</p>
               </ReadEl>
               <ReadEl>
                  <p>{data.courseName}</p>
               </ReadEl>
            </Col>
         );
      case "DomecqAcademy":
         return (
            <Col large={12} className="element">
               <ReadEl>
                  <p>Domecq Academy:</p>
               </ReadEl>
               <ReadEl>
                  <p>{parse(data.longDescription)}</p>
               </ReadEl>
            </Col>
         );
      default:
         return <p>{type}</p>;
   }
}

const ReadEl = styled.div`
   box-sizing: border-box;
   margin-right: 1em;
   backround: red;

   p,
   select {
      font-weight: 300;
      font-size: 0.9em;
      margin: 0;
      background-color: transparent;
   }
   select {
      margin-bottom: 1 em;
   }
   p {
      margin: 0.5em;
   }
`;
